import styled from "styled-components";
import { theme } from "../../../../helpers/theme";
import Icon from "../../../../components/icon";
import { ReactComponent as Padlock } from "../../../../assets/icons/padlock.svg";

interface ClientAddressSectionHeaderProps {
  isEditable: boolean;
  setIsEditable: (edit: boolean) => void;
}

const ClientAddressSectionHeader = ({
  isEditable,
  setIsEditable,
}: ClientAddressSectionHeaderProps) => {
  return (
    <ClientAddressSectionHeaderContainer>
      <HeaderName>Dane Adresowe</HeaderName>
      {!isEditable && (
        <SectionEditWrapper>
          <EditButton onClick={() => setIsEditable(true)}>Edytuj</EditButton>
          <Icon icon={<Padlock style={{ padding: 0 }} />} />
        </SectionEditWrapper>
      )}
    </ClientAddressSectionHeaderContainer>
  );
};

export default ClientAddressSectionHeader;
const ClientAddressSectionHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const HeaderName = styled.span`
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const SectionEditWrapper = styled.div`
  width: 30%;
  display: flex;
`;
const EditButton = styled.span`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  margin-right: 10px;
`;
